import callRequestFormBase from '../../../call-request-form-base/call-request-form-base';
import succeededFailedGtm from '../../../../common/succeeded-failed-gtm/succeeded-failed-gtm';
import resetTime from '../../../../common/reset-time/reset-time';
import setPayload from '../../../../common/set-payload/set-payload';
import defaultValidation from '../../../../common/default-validation/default-validation';
export default {
	mixins: [succeededFailedGtm, resetTime, setPayload, defaultValidation],
	extends: callRequestFormBase,
	methods: {
		resetForm() {
			this.resetTimeField();
			this.resetMainFields();
		}
	}
};
